/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 17/03/2025
*/


import BannerHome from "../components/home/bannerHome";
import OurStory from "../components/home/OurStory";
import WhyChooseUs from "../components/home/WhyChooseUs";
import OurProducts from "../components/home/ourProducts";
import WeCanHelp from "../components/home/weCanHelp";
import ClientComp from "../components/home/clientComp";

const Home = () => {

  return (

    <>
      <BannerHome />
      <OurProducts />
      <ClientComp />
      <WhyChooseUs />
      <OurStory />
      <WeCanHelp />
    </>


  );
};

export default Home;
